/**
 * 用户相关
 */
import {setLocalStorage, getLocalStorage} from '@/common/js/mUtils'
import * as API from '@/api/index'


const state = {
	fontsList: [],
}

const actions = {
    async fetchFontList({commit, state, dispatch}, data) {
        if (state.fontsList.length > 0) {
            return;
        }

        if (state.fontsList.length > 0) {
            return;
        }

		return new Promise(resolve => {
            API.listFonts({}).then((response) => {
                if (response.code == 0 || response.code == 1000) {
                    state.fontsList = response.data;
                }

                resolve();
            }).catch(e => {
                resolve();
            });

		});

    },
	async LOAD_FONT({commit, state, dispatch}, data){
        await dispatch('fetchFontList');

        const fontFamily = data.fontFamily;
        let find = undefined
        document.fonts.forEach(one => {
            if (find === undefined && one.family === fontFamily) {
                find = one.family;
            }
        })

        if (find === undefined) {
            let font2 = state.fontsList.find(one => one.name === fontFamily)
            if (font2 === undefined) {
                return;
            }
            console.log("加载字体" + fontFamily);

            const font = new FontFace(fontFamily, `url(${font2.woff})`)
            await font.load()
            document.fonts.add(font)
        } else {
            console.log("已经加载字体过了" + fontFamily);
        }

    }
};

const mutations = {
	
}


const getters = {
	getFontsList(state){
		return state.fontsList
	},
};


export default {
	state,
	actions,
	getters,
	mutations
}
